import React, { useEffect, useState } from 'react';

const TicketmasterEvents = () => {
  const [events, setEvents] = useState([]);
  const [error, setError] = useState(null);

  // useEffect(() => {
  //   const fetchEvents = async () => {
  //     const url = `https://app.ticketmaster.com/discovery/v2/events.json?classificationName=music&dmaId=324&apikey=mYGKpG6wDGYRbzAJMKEe53jgasgeQZZN`;

  //     try {
  //       const response = await fetch(url);
  //       const data = await response.json();

  //       if (data._embedded?.events) {
  //         setEvents(data._embedded.events);
  //       } else {
  //         setEvents([]);
  //       }
  //     } catch (err) {
  //       console.error(err);
  //       setError('Failed to fetch Ticketmaster events.');
  //     }
  //   };

  //   fetchEvents();
  // }, []);
// 🔁 Send all events in one POST
const insertEventsToWordPress = async (eventsData) => {
  try {
    const wpResponse = await fetch('https://rsvpevents.local/wp-json/custom/v1/insert-events', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        // 'X-WP-Nonce': wpApiSettings.nonce, // if using authentication
      },
      body: JSON.stringify(eventsData)
    });

    const result = await wpResponse.json();

    if (!wpResponse.ok) {
      console.error('Error inserting events:', result);
    } else {
      console.log('Events inserted successfully:', result);
    }
  } catch (err) {
    console.error('Error calling WordPress API:', err);
  }
};
useEffect(() => {
  const fetchEvents = async () => {
    const url = `https://app.ticketmaster.com/discovery/v2/events.json?classificationName=music&dmaId=324&apikey=mYGKpG6wDGYRbzAJMKEe53jgasgeQZZN`;

    try {
      const response = await fetch(url);
      const data = await response.json();

      if (data._embedded?.events) {
        const events = data._embedded.events;
        setEvents(events);

        // ✅ Only one call to insert all events
        await insertEventsToWordPress(events);
      } else {
        setEvents([]);
      }
    } catch (err) {
      console.error(err);
      setError('Failed to fetch Ticketmaster events.');
    }
  };

  fetchEvents();
}, []);

  
  return (
    <div>
      <h2>Upcoming Events</h2>
        <ul>
        {events.map(event => {
            const lat = event._embedded?.venues?.[0]?.location?.latitude;
            const lng = event._embedded?.venues?.[0]?.location?.longitude;
            const mapUrl = lat && lng ? `https://www.google.com/maps/@${lat},${lng},15z` : null;

            return (
            <li key={event.id}>
                <h2>{event.name}</h2>
                <div>
                <p><strong>Info:</strong> {event.info}</p>
                <p><strong>Date:</strong> {event.dates.start.localDate}</p>
                <p><strong>Time:</strong> {event.dates.start.localTime}</p>
                <p><strong>Image:</strong> {event.images?.[3]?.url}</p>
                <p><strong>Venue:</strong> {event._embedded?.venues?.[0]?.name}</p>
                <p><strong>City:</strong> {event._embedded?.venues?.[0]?.city?.name}</p>
                <p><strong>State:</strong> {event._embedded?.venues?.[0]?.state?.name}</p>
                <p><strong>Country:</strong> {event._embedded?.venues?.[0]?.country?.name}</p>
               
                <p><strong>Google Map Link:</strong> {mapUrl}</p>
                <p><strong>Ticket Link:</strong> {event.url}</p>
                <p><strong>Organizer:</strong> {event.promoters?.[0]?.name}</p>
                <p><strong>Artist Line Up:</strong></p>
                     <ul>
                    {event._embedded?.attractions?.map((attraction, index) => (
                        <li key={index}>{attraction.name}</li>
                    )) || <li>No attractions available</li>}
                    </ul>

                    <p><strong>Entry Options:</strong> Tickets</p>
                    <p><strong>Event Type:</strong> {event.type}</p>
                    <p><strong>Genre:</strong> </p>
                      <ul>
                    {event.classifications?.map((classification, index) => (
                        <li key={index}>{classification.genre?.name}</li>
                    )) || <li>No genres available</li>}
                    </ul>
                </div>

            </li>
            );
        })}
        </ul>
    </div>
  );
};

export default TicketmasterEvents;
